<mat-form-field class="full-width">
    <input type="text" (input)="onValueChangesInput($event)" [formControl]="control" [matAutocomplete]="auto" matInput
        name="autoComplete" required dividerColor="warn" [placeholder]="placeholder | translate">

    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
        (optionSelected)="onValueChanges($event.option.value)">
        <mat-option *ngFor="let option of filterOptions()" [value]="option">
            {{option}}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
